<template>
    <div class="page-container">
        <header class="header">
            <h1 class="main-title">Deine Übungen</h1>
            <p class="subtitle">
                Was möchtest du heute trainieren? Wähle eine Kategorie aus, die am besten zu dir passt.
            </p>
        </header>

        <section class="category-grid">
            <button 
                v-for="category in categories" 
                :key="category.id" 
                class="category-card"
                :class="{inactive: category.inactive }"
                @click="startExercise(category.id)"
            >
                <div class="card-icon">{{ category.icon }}</div>
                <h3 class="card-title">{{ category.title }}</h3>
                <p class="card-description">{{ category.description }}</p>
            </button>
        </section>
    </div>

    <div class="toast" v-if="toast">{{ toast }}</div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const toast = ref(null)

// Hier definieren wir unsere Kategorien. Emojis helfen als visuelle Anker!
const categories = [
    { 
        id: 'words', 
        title: 'Einzelne Wörter', 
        description: 'Schritt für Schritt. Konzentriere dich auf einzelne, wichtige Wörter.', 
        icon: '📝',
        inactive: true
    },
    { 
        id: 'short_sentences', 
        title: 'Kurze Sätze', 
        description: 'Übe den Zusammenhang mit einfachen und überschaubaren Sätzen.', 
        icon: '💬' ,
        inactive: true
    },
    { 
        id: 'long_sentences', 
        title: 'Lange Sätze', 
        description: 'Du fühlst dich sicher? Versuch dich an längeren Sätzen!', 
        icon: '📚' 
    },
    { 
        id: 'review', 
        title: 'Meine Stolperwörter', 
        description: 'Wiederhole die Wörter, die beim letzten Mal noch etwas knifflig waren.', 
        icon: '🔄' ,
        inactive: true
    }
]

const startExercise = (categoryId) => {
  if (categories.find(m=>m.id == categoryId).inactive) {
    toast.value = "Diese Kategorie ist aktuell noch nicht verfügbar. Bitte komme nächstes Jahr wieder an unseren Stand!"
    setTimeout(() => { toast.value = null; }, 5000)
    return
  }
    // Wir leiten zur Canvas-Seite weiter und hängen die Kategorie als "Query Parameter" an.
    // Die URL sieht dann z.B. so aus: /canvas?mode=short_sentences
    router.push({ path: '/canvas', query: { mode: categoryId } })
}
</script>

<style scoped lang="scss">

.toast {
  position: absolute;
  top: 20px;
  left: 10vw;
  width: 80vw;

  border: solid 2px var(--color-primary);
  border-radius: 20px;
  background: var(--color-accent);

  padding: 20px;
}

.page-container {
    width: 100%;
    min-height: 92%;
    padding: var(--spacing-lg) var(--spacing-xl);
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: var(--color-background-light);
}

.header {
    text-align: center;
    max-width: 600px;
    margin-bottom: var(--spacing-xl);

    .main-title {
        color: var(--color-primary);
        font-size: var(--font-size-xl, 2.5rem);
        margin-bottom: var(--spacing-sm);
    }

    .subtitle {
        color: var(--color-text-dark);
        font-size: var(--font-size-lg, 1.2rem);
        line-height: var(--line-height-base);
    }
}

.category-grid {
    display: grid;
    /* Ein responsives Grid: Auf großen Bildschirmen nebeneinander, auf Handys untereinander */
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: var(--spacing-lg);
    width: 100%;
    max-width: 1000px;
}

.category-card {
    background: white;
    border: 2px solid var(--color-accent);
    border-radius: 12px;
    padding: var(--spacing-lg);
    text-align: center;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);

    &.inactive {
      border-color: #ccc;

      .card-icon {
        filter: saturate(0);
      }

      .card-title {
        color: #ccc;
      }
    }

    /* Beim Hovern hebt sich die Karte leicht an und ändert die Randfarbe */
    &:hover, &:focus {
        transform: translateY(-5px);
        border-color: var(--color-primary);
        box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
        outline: none;
    }

    .card-icon {
        font-size: 3rem;
        margin-bottom: var(--spacing-md);
    }

    .card-title {
        color: var(--color-primary);
        font-size: var(--font-size-lg, 1.5rem);
        margin-bottom: var(--spacing-sm);
    }

    .card-description {
        color: var(--color-text-dark);
        line-height: 1.4;
    }
}
</style>